import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/punto_venta/facturas';
import Facturas from './FacturasList';


const ms2p = (state) => {
  return {
    ...state.factura_pv,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Facturas);
